import { getFileSpriteIconClass } from 'owa-file-icon';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import { FileProviderIconSize } from './getIconCSSForFileProvider';
import { assertNever } from 'owa-assert';

const classNames = require('classnames');
const styles = require('./fileProvidersIcon.scss');

const ONE_DRIVE_COLOR_24x24_SVG = require('./svg/OneDrive_Color_24x24.svg');
const ONE_DRIVE_COLOR_64x64_SVG = require('./svg/OneDrive_Color_64x64.svg');
const OUTLOOK_COLOR_16x16_SVG = require('./svg/Outlook_Color_16x16.svg');

export default function getIconForFileProvider(icon: string, className: string): JSX.Element {
    return <Icon iconName={icon} className={className} />;
}

export function getIconForGDrive(iconSize: FileProviderIconSize): JSX.Element {
    let gdriveIcon = 'gdrive_24x24';
    switch (iconSize) {
        case FileProviderIconSize.Small:
            gdriveIcon = 'gdrive_16x16';
            break;
        case FileProviderIconSize.Medium:
            gdriveIcon = 'gdrive_24x24';
            break;
        case FileProviderIconSize.Large:
            gdriveIcon = 'gdrive_64x64';
            break;
        default:
            assertNever(iconSize);
    }

    return (
        <Icon
            className={classNames([styles.pngGoogleIcon, getFileSpriteIconClass(gdriveIcon)])}
            tabIndex={-1}
            data-is-focusable={false}
        />
    );
}

export function getIconForOutlook(className?: string): JSX.Element {
    const imageData = {
        svgIcon: OUTLOOK_COLOR_16x16_SVG,
        className: styles.outlookSVGIconSmall,
    };
    return <img src={imageData.svgIcon} className={classNames([imageData.className, className])} />;
}

export function getIconForOneDrive(
    iconSize: FileProviderIconSize = FileProviderIconSize.Medium,
    className?: string
): JSX.Element {
    let imageData;
    switch (iconSize) {
        case FileProviderIconSize.Small:
            imageData = {
                svgIcon: ONE_DRIVE_COLOR_24x24_SVG,
                className: styles.oneDriveSVGIconSmall,
            };
            break;
        case FileProviderIconSize.Medium:
            imageData = {
                svgIcon: ONE_DRIVE_COLOR_24x24_SVG,
                className: styles.oneDriveSVGIcon,
            };
            break;
        case FileProviderIconSize.Large:
            imageData = {
                svgIcon: ONE_DRIVE_COLOR_64x64_SVG,
                className: styles.oneDriveSVGIconBig,
            };
            break;
        default:
            return assertNever(iconSize);
    }
    return <img src={imageData.svgIcon} className={classNames([imageData.className, className])} />;
}
